<template>

    <div class="container-fluid fixcontent " >

        <div class="row " style="margin-top: 1px; margin-bottom: -4px !important;" >
            <div class="col-md-2 text-light " style="padding-left: 0px !important;">

                <b-link class="" :to="{ path: '/' }">
                    <img class="col-md-12   " src="@/assets/images/headerlogo.png"   >
                </b-link>
            </div>
            <div class="col-md-6 text-center col-7 mt-4 text-light offset-1 font-weight-semi-bold" style="font-size: 17px">
                <welcomenote/>

            </div>
            <div class="col-md-3 text-right col-4 text-light mt-1" style="font-size: 17px" >
                <p style="margin-bottom: 0.3rem"><ShowRealTime/></p>
                <a class="text-light" href="#" @click.prevent="signOut" >Login</a> / <a class="text-light" href="#" @click.prevent="signOut">Logout</a>
            </div>
        </div>

        <div class="row mt-2">
            <sidebar></sidebar>
            <div class="col-md-11 bgsecond mt-2 text-light" >


                <div class="row  mb-1">
                    <div class="col-md-1 ">
                        <h1>Users</h1>
                    </div>
                    <div class="col-md-1 mt-2">
                        <b-link class="" :to="{ path: '/create-user' }">
                            <b-button class="btn-info " > Add New User </b-button>
                        </b-link>
                    </div>
                    <div class="col-md-2 mt-2">
                        <b-button class="btn-warning " @click="bulk_reset_passwords" :disabled="resetting_passwords || reset_timer_running" > Bulk Password Reset
                            <span v-if="resetting_passwords" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span v-if="reset_timer_running"> ({{ bulk_reset_countdown }} sec) </span>
                        </b-button>
                    </div>

                    <b-container fluid class="">
                        <b-card class="shadow-sm " body-class="p-0">
                            <div class="d-flex justify-content-end align-items-center p-3">
<!--                                <div>-->
<!--                                    <label class="mb-0" size="sm">{{'Filter by role'}}</label>-->
<!--                                    <b-form-select @change="filterUsers" class="ml-3" size="sm" value-field="id" text-field="name"-->
<!--                                                   :options="roles"-->
<!--                                                   style="width: 150px">-->
<!--                                        <template #first>-->
<!--                                            <b-form-select-option :value="''">&#45;&#45; Please select an option &#45;&#45;-->
<!--                                            </b-form-select-option>-->
<!--                                        </template>-->
<!--                                    </b-form-select>-->
<!--                                </div>-->
<!--                                <b-button v-can="'create user'" class="primary-btn ml-3" variant="info" size="sm"-->
<!--                                          to="/create-user">{{'Add New User'}}-->
<!--                                </b-button>-->
                            </div>
                            <b-table head-variant="dark" small :items="items" responsive bordered class="text-center" :fields="fields">
                                <template #cell(role)="data">
                                    <div v-for="item in data.item.roles" :key="item.id">
                                        {{ item.name }}
                                    </div>
                                </template>
                                <template #cell(actions)="data">
                                    <div class='d-flex justify-content-center'>
                                        <router-link v-can="'edit user'" :to="`/edit-user/${data.item.id}`">
                                            <b-icon variant="info" font-scale="1.5" icon="pencil-square"></b-icon>
                                        </router-link>
                                        <a v-can="'delete user'" @click="deleteUser(data.item.id,$event)" href="/users/delete-user"
                                           class="ml-2">
                                            <b-icon variant="danger" font-scale="1.5" icon="trash"></b-icon>
                                        </a>
                                    </div>
                                </template>
                            </b-table>
                        </b-card>
                    </b-container>





                </div>







            </div>



        </div>

    </div>

</template>




<script>
import {confirmDeleteAlert, errorAlert, successAlert} from "@/components/Alerts";
import Header from "@/components/layout/Header";
import ShowRealTime from "@/components/showrealtime.vue";
import Welcomenote from "@/pages/admin/mypos/welcomenote.vue";
import Salesmenleague from "@/pages/admin/mypos/salesmenleague.vue";
import BranchLeague from "@/pages/admin/mypos/branchleague.vue";
import Loader from "@/components/loader.vue";
import sidebar from "@/components/layout/sidebar.vue";
import Swal from "sweetalert2";
import axios from "axios";
import URL from "@/constants/baseurl";
import {cloneDeep} from "lodash";
//import PageHeader from "@/components/layout/PageHeader";
export default {
    name: "Users",
    mixins: [],
    components: {sidebar, Loader, BranchLeague, Salesmenleague, Welcomenote, ShowRealTime, Header},
    computed:{
        fields() {
            return [
                {
                    label:'Sr#',
                    key: 'id'
                },
                {
                    label:'First Name',
                    key: 'first_name'
                },
                {
                    label:'Last Name',
                    key: 'last_name'
                },
                {
                    label:'Email',
                    key: 'email'
                },
                {
                    label:'User Name',
                    key: 'user_name'
                },
                // {
                //     label:'CRR ID',
                //     key: 'customer_id_number'
                // },
                // {
                //     label:'Customer No',
                //     key: 'customer_number'
                // },
                // {
                //     label:'Payer No',
                //     key: 'payer_number'
                // },
                {
                    label:'Role',
                    key: 'role'
                },
                {
                    label:'Actions',
                    key: 'actions'
                },

            ]
        }
    },
    data() {
        return {

            resetting_passwords:false,
            bulk_reset_countdown: 180,
            reset_timer_running: false,
            reset_timer_interval: null,
            items: [],
            roles: [],
            user: {}
        }
    },
    created() {
        this.getUsers();
        this.getRoles();
    },
    beforeDestroy() {
        this.stop_bulk_reset_timer();
    },
    methods: {
        start_bulk_reset_timer() {
            this.bulk_reset_countdown = 180;
            this.reset_timer_running = true;
            this.reset_timer_interval = setInterval(() => {
                if (this.bulk_reset_countdown > 0) {
                    this.bulk_reset_countdown--;
                } else {
                    this.stop_bulk_reset_timer();
                }
            }, 1000);
        },
        stop_bulk_reset_timer() {
            if (this.reset_timer_interval) {
                clearInterval(this.reset_timer_interval);
                this.reset_timer_interval = null;
            }
            this.reset_timer_running = false;
        },
        async bulk_reset_passwords() {
            const result = await Swal.fire({
                title: 'Are you sure you want to reset bulk users passwords?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, reset!',
            });

            if (result.isConfirmed) {
                this.start_bulk_reset_timer();
                const apiToken = localStorage.getItem('token');
                if (apiToken) {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${apiToken}`;
                }

                try {
                    this.resetting_passwords = true;
                    const res = await axios.post(`${URL.BASEURL}/api/bulk-reset-passwords`);

                    if (res && res.data && res.data.length > 0) {
                        await this.getUsers();

                        // 1. Build the Tab-Separated string for clean copying to Excel/Notepad
                        let copyString = "Username\tEmail\tNew Password\n";

                        // 2. Build HTML table rows
                        let tableRows = res.data.map(user => {
                            // Append to the clipboard string
                            copyString += `${user.user_name || ''}\t${user.email || ''}\t${user.plain_password || ''}\n`;

                            // Return the HTML row
                            return `
                        <tr>
                            <td style="border: 1px solid #ddd; padding: 8px; text-align: left;">${user.user_name || ''}</td>
                            <td style="border: 1px solid #ddd; padding: 8px; text-align: left;">${user.email || ''}</td>
                            <td style="border: 1px solid #ddd; padding: 8px; text-align: left; font-weight: bold; color: #d33;">${user.plain_password || ''}</td>
                        </tr>
                    `;
                        }).join('');

                        // 3. Add the Copy button and the Table to the HTML template
                        const tableHtml = `
                    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
                        <button id="copyCredsBtn" style="background-color: #17a2b8; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; font-size: 14px; font-weight: bold;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-clipboard" viewBox="0 0 16 16" style="margin-right: 5px; vertical-align: text-top;">
                                <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                            </svg>
                            Copy to Clipboard
                        </button>
                    </div>
                    <div style="max-height: 300px; overflow-y: auto;">
                        <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
                            <thead>
                                <tr style="background-color: #f2f2f2;">
                                    <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Username</th>
                                    <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">Email</th>
                                    <th style="border: 1px solid #ddd; padding: 8px; text-align: left;">New Password</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${tableRows}
                            </tbody>
                        </table>
                    </div>
                `;

                        // 4. Fire SweetAlert and attach the clipboard event listener
                        this.stop_bulk_reset_timer()
                        Swal.fire({
                            title: 'Passwords Reset Successfully',
                            html: tableHtml,
                            icon: 'success',
                            width: '600px',
                            confirmButtonText: 'Close',
                            didOpen: () => {
                                const copyBtn = document.getElementById('copyCredsBtn');
                                if (copyBtn) {
                                    copyBtn.addEventListener('click', () => {
                                        // Write the TSV string to the system clipboard
                                        navigator.clipboard.writeText(copyString).then(() => {
                                            // Visual feedback
                                            const originalText = copyBtn.innerHTML;
                                            copyBtn.innerHTML = `
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16" style="margin-right: 5px; vertical-align: text-top;">
                                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                        </svg>
                                        Copied!
                                    `;
                                            copyBtn.style.backgroundColor = '#28a745'; // Bootstrap success green

                                            // Revert button text after 2 seconds
                                            setTimeout(() => {
                                                copyBtn.innerHTML = originalText;
                                                copyBtn.style.backgroundColor = '#17a2b8'; // Revert to info blue
                                            }, 2000);
                                        }).catch(err => {
                                            console.error('Failed to copy text: ', err);
                                            alert('Failed to copy to clipboard.');
                                        });
                                    });
                                }
                            }
                        });

                    } else {
                        Swal.fire('Info', 'No passwords were reset or no users found.', 'info');
                    }
                } catch (error) {
                    console.error(error);
                    Swal.fire('Error', 'Failed to reset passwords.', 'error');
                } finally {
                    this.resetting_passwords = false;
                }
            }
        },
        async getUsers(role = '') {
            const {data} = await this.$axios.get(`user?role=${role}`);
            this.items = data;
        },
        async deleteUser(id, e) {
            e.preventDefault()
            const {isConfirmed} = await confirmDeleteAlert('user');
            if (isConfirmed) {
                try {
                    await this.$axios.delete(`user/${id}`);
                    await successAlert('User', 'deleted')
                    await this.getUsers();
                } catch (e) {
                    await errorAlert('User', 'deleting');
                }
            }
        },
        async getRoles() {
            const {data} = await this.$axios.get('role');
            this.roles = data.roles;
        },
        filterUsers(value) {
            this.getUsers(value)
        }
    }
}
</script>

<style scoped>

</style>
